import { constants, typographyStyles } from "@newsela/angelou";
import { CSSObject } from "@emotion/react";

const { textMObj } = typographyStyles;

const { colors } = constants;

export const rootCss: CSSObject = {
  color: colors.ui.neutral[600],
  whiteSpace: "pre-line",
  paddingInlineStart: 0,
  paddingInlineEnd: 0,
  ...textMObj,
};

export const containerCss: CSSObject = {
  margin: "24px 0",
};
